import { Menu, ShoppingBag, X } from "lucide-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext.jsx";
import { Logo } from "./Logo.jsx";

const links = [
  ["/boutique", "Boutique"],
  ["/promotions", "Promotions"],
  ["/comment-ca-marche", "Comment ça marche"],
  ["/a-propos", "Notre mission"],
  ["/contact", "Contact"],
];

export function Header() {
  const [open, setOpen] = useState(false);
  const { itemCount } = useCart();

  return (
    <>
      <div className="announcement">
        <span>Jusqu’à 30 % d’économie sur le catalogue</span>
        <span className="announcement__dot" />
        <span>Livraison offerte dès 40 €</span>
      </div>
      <header className="site-header">
        <div className="container site-header__inner">
          <Logo />
          <nav className={`main-nav ${open ? "is-open" : ""}`} aria-label="Navigation principale">
            {links.map(([to, label]) => (
              <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>
            ))}
          </nav>
          <div className="header-actions">
            <NavLink className="cart-link" to="/panier" aria-label={`Panier, ${itemCount} article${itemCount > 1 ? "s" : ""}`}>
              <ShoppingBag size={21} />
              <span>Panier</span>
              {itemCount > 0 && <b>{itemCount}</b>}
            </NavLink>
            <button className="menu-toggle" type="button" onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label="Ouvrir le menu">
              {open ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
